<template>
  <div>
    <div v-if="total > 1 && total >= current" class="pagination-wrap">
      <!-- Previous -->
      <a
        class="pagination-button-prev"
        href="javascript:void(0)"
        :class="{
          disabled: current == 1,
          'pointer-events-none': current == 1
        }"
        @click="setPage(current - 1)"
      >
        <img src="/assets/img/svg/arrow_back.svg" alt="" />
      </a>

      <!-- Less or equal to 5 -->
      <div v-if="total <= 5" class="flex">
        <a
          v-for="number in total"
          :key="number"
          class="pagination-button"
          :class="{ active: number == current }"
          href="javascript:void(0)"
          @click="setPage(number)"
          >{{ number }}</a
        >
      </div>

      <!-- More than 5 -->
      <div v-else class="flex">
        <a
          v-if="current != 1"
          class="pagination-button"
          href="javascript:void(0)"
          @click="setPage(1)"
          >1</a
        >
        <span v-if="current > 3">...</span>
        <a
          v-if="current > 2"
          class="pagination-button"
          href="javascript:void(0)"
          @click="setPage(current - 1)"
          >{{ current - 1 }}</a
        >
        <a
          class="pagination-button active"
          href="javascript:void(0)"
          @click="setPage(current)"
          >{{ current }}</a
        >
        <a
          v-if="current < total - 1"
          class="pagination-button"
          href="javascript:void(0)"
          @click="setPage(current + 1)"
          >{{ current + 1 }}</a
        >
        <span v-if="current < total - 2">...</span>

        <a
          v-if="current != total"
          class="pagination-button"
          href="javascript:void(0)"
          @click="setPage(total)"
          >{{ total }}</a
        >
      </div>

      <!-- Next -->
      <a
        class="pagination-button-next"
        href="javascript:void(0)"
        :class="{
          disabled: current >= total,
          'pointer-events-none': current >= total
        }"
        @click="setPage(current + 1)"
      >
        <img src="/assets/img/svg/arrow_back.svg" alt="" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    current: { type: Number, required: true },
    total: { type: Number, required: true }
  },
  emits: ["setPage"],
  methods: {
    setPage(pageNumber) {
      this.$emit("setPage", pageNumber);
    }
  }
};
</script>
